require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/object/get-prototype-of.js
// module id = 516
// module chunks = 0 1